import React from 'react';

import LinkButton from '@atlaskit/button/link';

const LinkButtonRovoExample = (): React.JSX.Element => {
	return (
		<LinkButton appearance="rovo" href="https://atlassian.com/software/rovo">
			Rovo link button
		</LinkButton>
	);
};

export default LinkButtonRovoExample;
